import * as React from 'react'
import { ReactElement } from 'react'
import { Accordion, AccordionHeader, AccordionItem, AccordionPanel, makeStyles, Text } from '@fluentui/react-components'
import { LineItemProps } from './LineItem/LineItem'
import { IObjectWithKey, ISelection, Stack } from '@fluentui/react'
import SelectableLineItem from './LineItem/SelectableLineItem'
import { LineItemType } from '../../../../config/finance/invoiceConfig'
import { LineItemEntity } from '../../../../hooks/finance/invoice/useLineItemEntities'
import { useTranslation } from 'react-i18next'
import { LineItemGroupProps } from './LineItemGroup/LineItemGroup'

export type LineItemSelectorProps = Omit<LineItemGroupProps, 'prefix' | 'isDragging' | 'setCurrentLineItem'> &
    Omit<LineItemProps<LineItemEntity>, 'entity' | 'lineItemType'> & {
        entities: Map<LineItemType, LineItemEntity[]>
        selection: ISelection<LineItemEntity & IObjectWithKey>
    }

const useStyles = makeStyles({
    accordion: {
        marginLeft: 0,
        marginRight: 0,
        paddingLeft: 0,
        paddingRight: 0,
    },
})

export default function LineItemSelector(props: LineItemSelectorProps): ReactElement {
    const styles = useStyles()
    const { t: translate } = useTranslation()

    return (
        <Accordion multiple collapsible defaultOpenItems={[...props.entities.keys()]}>
            {[...props.entities.entries()].map(([lineItemType, entities]) => (
                <AccordionItem value={lineItemType} key={lineItemType}>
                    <AccordionHeader className={styles.accordion}>
                        {translate(`invoice.edit.form.invoiceline.type.${lineItemType.toLowerCase().replaceAll(/[-_]/g, '')}`)}
                    </AccordionHeader>
                    <AccordionPanel className={styles.accordion}>
                        <Stack tokens={{ padding: '0 0 s1 0' }}>
                            {entities.length > 0 ? (
                                entities.map(entity => (
                                    <SelectableLineItem
                                        key={entity.id}
                                        lineItemType={lineItemType}
                                        entity={entity}
                                        isSelected={props.invoice?.lineItemGroups
                                            .flatMap(group => group.lineItems)
                                            .some(item => entity.id === item.id)}
                                        {...props}
                                    />
                                ))
                            ) : (
                                <Stack horizontalAlign="center">
                                    <Text italic>{translate('invoice.edit.form.invoiceline.type.empty')}</Text>
                                </Stack>
                            )}
                        </Stack>
                    </AccordionPanel>
                </AccordionItem>
            ))}
        </Accordion>
    )
}
